// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonCutScissors_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.3024 4.4641L12.5703 0L6.23961 10.9651C5.69018 10.3491 4.89039 9.96118 4 9.96118C2.34315 9.96118 1 11.3043 1 12.9612C1 14.618 2.34315 15.9612 4 15.9612C5.32235 15.9612 6.44487 15.1056 6.84423 13.9179L7.99949 11.9169L9.15721 13.9221C9.55782 15.1077 10.6792 15.9612 12 15.9612C13.6569 15.9612 15 14.618 15 12.9612C15 11.3043 13.6569 9.96118 12 9.96118C11.1093 9.96118 10.3092 10.3494 9.75977 10.9658L9.15419 9.9169L12.3024 4.4641ZM5 12.9612C5 13.5135 4.55228 13.9612 4 13.9612C3.44772 13.9612 3 13.5135 3 12.9612C3 12.4089 3.44772 11.9612 4 11.9612C4.55228 11.9612 5 12.4089 5 12.9612ZM13 12.9612C13 13.5135 12.5523 13.9612 12 13.9612C11.4477 13.9612 11 13.5135 11 12.9612C11 12.4089 11.4477 11.9612 12 11.9612C12.5523 11.9612 13 12.4089 13 12.9612Z" class="svg-bg"/>
  <path d="M3.70154 4.47265L3.43359 0.00854492L6.85003 5.92598L5.69533 7.92598L3.70154 4.47265Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.26861 0L5.53655 6.19615L9.69127 13.3923L10.846 11.3923L4.26861 0Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.46516 17.784C9.12581 17.195 8.63164 16.6848 8.00067 16.3205C6.0875 15.2159 3.64114 15.8714 2.53657 17.7846C1.432 19.6978 2.0875 22.1441 4.00067 23.2487C5.91383 24.3533 8.36016 23.6978 9.46476 21.7847L12.0007 17.3923L14.5256 21.7656L14.5365 21.7847C15.6411 23.6979 18.0875 24.3534 20.0006 23.2488C21.9138 22.1442 22.5693 19.6979 21.4647 17.7847C20.3602 15.8715 17.9138 15.216 16.0006 16.3206C15.3697 16.6849 14.8755 17.1951 14.5362 17.784L13.1554 15.3923L18.4648 6.1962L19.7327 4.62337e-05L9.46516 17.784ZM16.2686 20.7847L16.261 20.7714C15.7194 19.8168 16.0485 18.6024 17.0006 18.0527C17.9572 17.5004 19.1804 17.8281 19.7327 18.7847C20.285 19.7413 19.9572 20.9645 19.0006 21.5168C18.0441 22.069 16.8209 21.7413 16.2686 20.7847ZM5.00066 21.5167C5.95725 22.0689 7.18043 21.7412 7.73271 20.7846C8.285 19.828 7.95725 18.6048 7.00066 18.0526C6.04408 17.5003 4.8209 17.828 4.26861 18.7846C3.71633 19.7412 4.04408 20.9644 5.00066 21.5167Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonCutScissors is a generated icon component.
 */
let IconCommonCutScissors = IconCommonCutScissors_1 = class IconCommonCutScissors extends IconBaseElement {
    render() {
        return html `${IconCommonCutScissors_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonCutScissors.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonCutScissors = IconCommonCutScissors_1 = __decorate([
    customElement('zui-icon-common-cut-scissors')
], IconCommonCutScissors);
export { IconCommonCutScissors };
